export const compositeItemConfig = {
  querySelector: 'ws-composite-item',
  directions: [
    'top-left',
    'top-center',
    'top-right',
    'center-left',
    'center-right',
    'bottom-left',
    'bottom-center',
    'bottom-right',
  ],
};
